import { formatInTimeZone } from 'date-fns-tz';
import { format, addDays } from 'date-fns';

export const getDateBegining = (startDate, isEnd) =>
  Number(formatInTimeZone(new Date(), 'Europe/Stockholm', 'yyyyMMdd')) >
  Number(format(new Date(startDate), 'yyyyMMdd'))
    ? formatInTimeZone(
        isEnd ? addDays(new Date(), 2) : addDays(new Date(), 1),
        'Europe/Stockholm',
        'yyyy-MM-dd',
      )
    : null;
